import { render } from "./Privileges.vue?vue&type=template&id=5b873166&scoped=true&ts=true"
import script from "./Privileges.vue?vue&type=script&lang=ts"
export * from "./Privileges.vue?vue&type=script&lang=ts"

import "./Privileges.vue?vue&type=style&index=0&id=5b873166&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b873166"]])

export default __exports__